import { render, staticRenderFns } from "./TriggersForm.vue?vue&type=template&id=359fd8f8"
import script from "./TriggersForm.vue?vue&type=script&lang=js"
export * from "./TriggersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports